import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const overlayLayerRecipeFn = /* @__PURE__ */ createRecipe('overlayLayer', {}, [])

const overlayLayerRecipeVariantMap = {}

const overlayLayerRecipeVariantKeys = Object.keys(overlayLayerRecipeVariantMap)

export const overlayLayerRecipe = /* @__PURE__ */ Object.assign(memo(overlayLayerRecipeFn.recipeFn), {
  __recipe__: true,
  __name__: 'overlayLayerRecipe',
  __getCompoundVariantCss__: overlayLayerRecipeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: overlayLayerRecipeVariantKeys,
  variantMap: overlayLayerRecipeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, overlayLayerRecipeVariantKeys)
  },
  getVariantProps: overlayLayerRecipeFn.getVariantProps,
})